import * as React from "react";

type TodoButtonProps = {
  todoUrl: string;
  todoAction: string;
  caseName: string;
  timeOnCase: string;
};

const TodoButton = ({
  todoUrl,
  todoAction,
  caseName,
  timeOnCase,
}: TodoButtonProps) => (
  <a
    href="#"
    data-url={todoUrl}
    role="button"
    aria-label="Save quiz to do list"
    className="finish-card-todo-button"
    id="todoURLButton"
    onClick={(e) => {
      e.preventDefault();
      fetch(todoUrl)
        .then((response) => response.text())
        .then((html) => (window as any).Turbo.renderStreamMessage(html))
        .then(() => {
          const el = document.getElementById("todo_form_container");
          if (el) el.classList.remove("hidden");
        });
    }}
  >
    {todoAction}
  </a>
);

export default React.memo(TodoButton);
